<template>
  <div>
    <v-card outlined>
      <!-- <h2 class="text-center colorblue">Настройка рассылки по 223 ФЗ</h2> -->
      <!-- <v-row no-gutters>
        <v-col cols="12" sm="12" md="12" class="pl-4 pr-4 pt-4 pb-4">
          <div class="add-bank">
            <v-combobox
              v-model="selectBank"
              :items="banks"
              item-text="name"
              label="Выберите банк для добавления"
              multiple
              dense
            />
            <v-btn color="warning" @click="addBank">
              <v-icon left> mdi-plus </v-icon>
              Добавить
            </v-btn>
          </div>
        </v-col>
      </v-row> -->
      <!-- <v-row v-if="selectedBanks.length">
        <v-col cols="12" sm="12" md="12" class="pl-4 pr-4 pt-4 pb-4">
          <v-data-table
            :headers="headers"
            :items="sortedBanks"
            :items-per-page="10"
            :loading="load"
            sort-by="idx"
          >
            <template v-slot:item.logo="{ item }">
              <img
                :src="item.logo"
                :alt="`Лого банка ${item.name}`"
                class="banks-logo"
              />
            </template>
            <template v-slot:item.procent="{ item }">
              <v-text-field
                v-model="item.procent"
                label="процент"
                type="number"
                :step="0.01"
                :max="100"
                :min="0.01"
              />
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="btn-group">
                <v-icon
                  class="onHover"
                  @click="deleteBank(item)"
                  title="Удалить банк"
                  >delete</v-icon
                >
                <v-icon
                  class="onHover"
                  @click="upBank(item)"
                  v-if="item.idx > 0"
                  title="Поднять вверх"
                  >mdi-arrow-up-thin</v-icon
                >
                <v-icon
                  class="onHover"
                  @click="downBank(item)"
                  v-if="item.idx < selectedBanks.length - 1"
                  title="Отпустить вниз"
                  >mdi-arrow-down-thin</v-icon
                >
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row> -->
      <v-row no-gutters>
        <v-col cols="12" sm="12" md="12" v-if="turnOn">
          <div class="btn-group">
            <v-btn color="success" @click="SaveWinners" :disabled="load">
              <v-icon left> mdi-content-save </v-icon>
              Сохранить
              <loading v-if="load" />
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="12" class="pl-4 pr-4 pt-4 pb-4">
          <v-checkbox
            v-model="turnOn"
            :label="!turnOn ? 'Рассылка выключена' : 'Рассылка включена'"
          />
        </v-col>
        <v-col cols="12" class="pl-4 pr-4 pb-4" v-if="turnOn">
          <v-row no-gutters>
            <v-col sm="12" md="3"
              ><v-checkbox
                label="Тестовая рассылка"
                v-model="malingTest"
                class="check"
            /></v-col>
            <v-col sm="12" md="9"
              ><v-text-field
                v-model="testEmail"
                label="Тестовый Email"
                type="text"
                :step="0.1"
                :max="1"
                :min="0.1"
                v-if="malingTest"
            /></v-col>
            <v-col cols="12">
              <p>&lt;%= shortName %&gt; // Наименование организации</p>
              <p>&lt;%= inn %&gt; // ИНН организации</p>
              <p>&lt;%= protocolLink %&gt; // линк на протокол по закупке</p>
              <p>&lt;%= protocol.notificationNumber %&gt; // Номер протокола</p>
              <p>&lt;%= protocol.name %&gt; // Предмет закупки</p>
              <p>&lt;%= unsubscribe %&gt; // Ссылка на отписатся</p>
              <p>&lt;%= link %&gt; // ссылка на формить гарантию</p>
              <p>
                &lt;%= protocol %&gt; // Доступны поля все которые есть в
                протоколе
              </p>
              <p>management - может быть объектом а может быть undefined</p>
              <p>&lt;%= management?.name %&gt; // ФИО управленца</p>
              <p>&lt;%= management?.firstName %&gt; // Фамилия управленца</p>
              <p>&lt;%= management?.secondName %&gt; // Имя управленца</p>
              <p>&lt;%= management?.lastName %&gt; // Отчество управленца</p>
              <p>&lt;%= management?.post %&gt; // Роль управленца</p>
              <p>
                &lt;% if( management && management.firstName &&
                management.secondName) { %&gt;
                <span
                  >&lt;%= management.firstName %&gt; &lt;%=
                  management.secondName %&gt;!, здравствуйте!</span
                >
                &lt;% }else{ %&gt;
                <span>Здравствуйте! &lt;%= shortName %&gt;</span>
                &lt;% } %&gt; // если management есть то вставляем ФИО
                управленца иначе наименование организации
              </p>
            </v-col>
            <h4 class="pt-4 pb-4">
              Шаблон непосредственно в темной части кода
            </h4>

            <br />
          </v-row>
          <HtmlViewer v-model="docs" height="70vh" />
          <v-col md="12">
            <v-row no-gutters>
              <v-col
                sm="3"
                md="3"
                class="pl-4 pr-4"
                style="
                  display: flex;
                  column-gap: 20px;
                  justify-content: space-around;
                "
                ><v-checkbox
                  label="Смена темы в письме"
                  v-model="showTitle"
                  class="check" />
                <v-checkbox
                  label="Составная тема"
                  v-model="compositeTitle"
                  class="check"
              /></v-col>
              <v-col sm="9" md="9" class="pl-4 pr-4">
                <v-text-field
                  v-model="title"
                  label="Тема письма"
                  type="text"
                  v-if="showTitle"
                />
                <span v-if="compositeTitle">{{
                  `Для "\${company_name}". ${title}`
                }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <div class="btn-group">
            <v-btn color="success" @click="SaveWinners" :disabled="load">
              <v-icon left> mdi-content-save </v-icon>
              Сохранить
              <loading v-if="load" />
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import loading from "../../components/loading.vue";
import HtmlViewer from "../../components/HtmlViewer.vue";

export default {
  name: "fz223",
  components: { loading, HtmlViewer },
  data: () => ({
    load: false,
    // selectBank: [],
    // selectedBanks: [],
    // headers: [
    //   { text: "", value: "logo" },
    //   {
    //     text: "Название",
    //     align: "start",
    //     sortable: true,
    //     value: "name",
    //   },
    //   { text: "ИНН", value: "inn" },
    //   { text: "Рейтинг", value: "acra" },
    //   { text: "Процент", value: "procent" },
    //   { text: "Действия", value: "actions" },
    // ],
    turnOn: false,
    malingTest: false,
    testEmail: "",
    docs: "",
    showTitle: false,
    compositeTitle: false,
    title: "",
  }),
  // computed: {
  //   banks() {
  //     const b = this.$store.getters.getBanksCS;
  //     for (const item of b) {
  //       item.procent = 0;
  //     }
  //     return b;
  //   },
  //   banksLogo() {
  //     return this.$store.getters.getBanksLogos;
  //   },
  //   sortedBanks() {
  //     const banks = [...this.selectedBanks];
  //     return banks
  //       .sort((a, b) => a.idx - b.idx)
  //       .filter((item) => (item.active === 1 ? true : false));
  //   },
  // },
  methods: {
    // upBank(bank) {
    //   const banks = [...this.selectedBanks];
    //   const idx = bank.idx;
    //   this.selectedBanks = banks.map((item) => {
    //     if (item.idx === idx - 1) {
    //       item.idx = idx;
    //       return item;
    //     }
    //     if (item.idx === idx) {
    //       item.idx = idx - 1;
    //       return item;
    //     }
    //     return item;
    //   });
    // },
    // downBank(bank) {
    //   const banks = [...this.selectedBanks];
    //   const idx = bank.idx;
    //   this.selectedBanks = banks.map((item) => {
    //     if (item.idx === idx + 1) {
    //       item.idx = idx;
    //       return item;
    //     }
    //     if (item.idx === idx) {
    //       item.idx = idx + 1;
    //       return item;
    //     }
    //     return item;
    //   });
    // },
    // addBank() {
    //   this.selectedBanks = [...this.selectedBanks, ...this.selectBank];
    //   this.selectedBanks = this.selectedBanks.map((item) => {
    //     const logo = this.banksLogo.filter((l) => l.id === item.id)[0];
    //     item.logo = logo?.logo ? logo.logo : null;
    //     return item;
    //   });
    //   this.normilizeBanksIdx();
    //   this.selectBank = [];
    // },
    // deleteBank(item) {
    //   this.selectedBanks = this.selectedBanks.filter(
    //     (row) => item.id !== row.id
    //   );
    //   this.normilizeBanksIdx();
    // },
    // normilizeBanksIdx() {
    //   this.selectedBanks = this.selectedBanks.map((item, idx) => {
    //     item.idx = idx;
    //     return item;
    //   });
    // },
    async SaveWinners() {
      const saveObj = {
        // banks: this.selectedBanks,
        // procents: this.procents,
        turnOn: this.turnOn,
        malingTest: this.malingTest,
        testEmail: this.testEmail,
        docs: this.docs,
        showTitle: this.showTitle,
        compositeTitle: this.compositeTitle,
        title: this.title,
      };
      this.$store.dispatch("SaveWinnersFZ223", saveObj);
    },
    async init() {
      this.load = true;
      // if (!this.banks.length) {
      //   await this.$store.dispatch("GetCalcSettingsCS");
      // }
      // if (!this.banksLogo.length) {
      //   await this.$store.dispatch("GET_BANKS_LOGOS");
      // }

      const { data } = await this.$store.dispatch("LoadWinnersFZ223");

      // this.selectedBanks = data.banks;
      // this.procents = data.procents;
      this.turnOn = data.turnOn;
      this.malingTest = data.malingTest;
      this.testEmail = data.testEmail;
      this.docs = data.docs;
      this.showTitle = data.showTitle;
      this.compositeTitle = data.compositeTitle;
      this.title = data.title;
      this.load = false;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="sass">
.add-bank
  display: flex
  align-items: center
  column-gap: 20px
.btn-group
  margin: 10px 20px 20px 20px
  display: flex
.pd-1
  padding: 1rem !important
.pd-1-2
  padding: 1rem 2rem !important
.banks-logo
  width: 35px
</style>
